export default "<img src=\"/assets/404.png\" width=\"100%\" height=\"auto\">"